import React from 'react';
import './ItemGroup.scss';

interface Props {
    children: React.ReactNode;
    border?: 'l' | 'xl';
}

const ItemGroup: React.FC<Props> = ({ children, border = 'l' }) => {
    const className = ['ItemGroup'].join(' ').replace(/\s{2,}/g, ' ');

    return <div className={`${className} border-${border}`}>{children}</div>;
};

export default ItemGroup;
